module.exports = __webpack_public_path__ + "img/tu18.4f361c01.jpg";